import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-4xl w-full bg-background rounded-lg shadow-lg">
        {/* Fixed Header */}
        <div className="p-6 border-b border-primary/10">
          <div className="flex items-center">
            <button
              onClick={() => navigate('/')}
              className="text-primary hover:text-secondary transition-colors mr-4 flex items-center group"
            >
              <FaArrowLeft className="mr-2 group-hover:-translate-x-1 transition-transform" />
              Back to Mint
            </button>
            {/* <h1 className="text-3xl font-semibold text-primary custom-font">
              Terms and Conditions
            </h1> */}
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="p-6 max-h-[70vh] overflow-y-auto custom-scrollbar">
          <div className="space-y-6 text-primary custom-font">
            <h2 className="text-2xl font-bold">Dæmons NFT Sale - Terms and Conditions</h2>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">1. Agreement to Terms</h3>
              <p className="leading-relaxed">
                By purchasing an NFT (non-fungible token) from Ikigai Studios' Dæmons NFT sale, you agree to comply with and be bound by these Terms and Conditions. Please read these terms carefully before making a purchase. If you do not agree to these terms, you should not purchase any NFT from Ikigai Studios.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">2. Eligibility</h3>
              <p className="leading-relaxed">
                You must be at least 18 years of age to participate in the Dæmons NFT sale. By purchasing an NFT, you confirm that you meet this age requirement.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">3. Description of NFTs</h3>
              <p className="leading-relaxed">
                Each NFT represents a digital collectible associated with the Dæmons blockchain game. NFTs may grant access to in-game benefits, features, and other virtual goods but do not represent ownership of any tangible assets. The purchase is for digital assets only, with no additional physical goods.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">4. Purchase and Payment</h3>
              <p className="leading-relaxed">
                All purchases are final. Payment for NFTs must be made using accepted cryptocurrency payment methods as indicated at checkout. By purchasing, you acknowledge that you have the necessary funds and authorizations to complete the transaction. Ikigai Studios reserves the right to refuse any purchase if fraudulent activity is suspected or if the transaction violates any applicable laws or regulations.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">5. Ownership and License</h3>
              <p className="leading-relaxed">
                Upon purchase, you receive ownership of the specific NFT, recorded on the blockchain. Ownership of the NFT does not grant intellectual property rights over the Dæmons project or game.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">6. Refunds and Cancellations</h3>
              <p className="leading-relaxed">
                All NFT sales are final. Dæmons does not offer refunds or cancellations after the transaction is completed. As blockchain transactions are immutable, Dæmons cannot reverse or modify any transaction once it has been confirmed.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">7. Tax Responsibility</h3>
              <p className="leading-relaxed">
                Buyers are responsible for any tax obligations that may arise from purchasing, holding, or selling the NFT according to the laws of their jurisdiction. Dæmons disclaims any responsibility for calculating, reporting, or remitting taxes related to NFT transactions.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">8. Risks</h3>
              <p className="leading-relaxed">
                By purchasing an NFT, you acknowledge and agree that blockchain technology is subject to risks, including fluctuations in the value of cryptocurrency, technical failures, and changes in regulatory policies. You assume full responsibility for understanding and managing these risks.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">9. Compliance with Local Laws</h3>
              <p className="leading-relaxed">
                While Dæmons complies with New Zealand laws, you are responsible for ensuring that participation in the NFT sale does not violate the laws of your own jurisdiction. Dæmons disclaims responsibility for any violations of foreign law.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">10. Limitation of Liability</h3>
              <p className="leading-relaxed">
                To the fullest extent permitted by law, Ikigai Studios, its officers, directors, employees, and agents are not liable for any direct, indirect, incidental, or consequential damages arising from your purchase, possession, or use of the NFT. This includes, but is not limited to, any potential loss in value or security issues associated with blockchain technology.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">11. Dispute Resolution</h3>
              <p className="leading-relaxed">
                All disputes arising out of or related to these terms shall be governed by the laws of New Zealand. Disputes shall be resolved through mediation or arbitration in New Zealand.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">12. Amendments</h3>
              <p className="leading-relaxed">
                Ikigai Studios reserves the right to amend these Terms and Conditions at any time without prior notice. Any changes will be posted on our website and/or official social channels. Continued participation in the Dæmons ecosystem constitutes acceptance of the amended terms.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">13. Contact Information</h3>
              <p className="leading-relaxed">
                For questions regarding these Terms and Conditions, please contact Dæmons at <a href="mailto:daemons_gamefi@gmail.com" className="link-hover">daemons_gamefi@gmail.com</a>.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-xl font-bold">14. Acceptance of Terms</h3>
              <p className="leading-relaxed">
                By making a purchase, you acknowledge that you have read, understood, and agree to these Terms and Conditions.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;